export enum DraggableItemType {
	FormBuilderComponent = "FORM_BUILDER_COMPONENT"
}